.root {
  flex-direction: column;
}

.waveRow {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fab {
  position: absolute;
  left: calc(50% - 28px);
  z-index: 100;
}

.loadingSpinner {
  color: var(--tuna-palette-secondary-contrastText);
}

.popupPaper {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  border-radius: 0;
  border-left: 2px solid var(--tuna-palette-secondary-main);
  align-items: center;
  display: flex;
  flex-direction: column;
}
